import PropTypes from 'prop-types';
import pick from 'lodash.pick';

/**
 * Full shape of experience data model
 */
const Shape = {
  appId: PropTypes.string,
  archivedAt: PropTypes.number,
  archivedBy: PropTypes.string,
  createdBy: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  previewUrl: PropTypes.string,
  published: PropTypes.bool,
  publishedAt: PropTypes.string,
  publishedBy: PropTypes.string,
  state: PropTypes.oneOf([
    'ARCHIVED',
    'DRAFT',
    'PUBLISHED',
    'TEST',
    'VERSIONED',
  ]),
  // FIXME: Define full shape of step
  steps: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  tagIds: PropTypes.arrayOf(PropTypes.string),
  theme: PropTypes.objectOf(
    PropTypes.shape({
      themeId: PropTypes.string,
      accountId: PropTypes.string,
    })
  ),
  traits: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.oneOf(['journey']),
  unpublishedAt: PropTypes.string,
  unpublishedBy: PropTypes.string,
  updatedAt: PropTypes.number,
  updatedBy: PropTypes.string,
};

/**
 * Allowed fields for storage
 */
const allowed = [
  'appId',
  'createdAt',
  'createdBy',
  'id',
  'name',
  'previewUrl',
  'published',
  'publishedAt',
  'state',
  'steps',
  'tagIds',
  'updatedAt',
  'updatedBy',
];

/**
 * Experience parsing function
 *
 * @param {Object<keyof Experience>} experience - Object with experience fields
 * @return {Object<keyof Experience>} Object with parsed experience fields
 */
export const parse = experience => pick(experience, allowed);

export default PropTypes.shape(parse(Shape));
